import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services';
import {
  parseServicesPanelFilterParamsFromStorage,
  parseServicesTownsFromStorage,
  serializeIdList,
} from '../filters';

/**
 * Hydrates the URL from localStorage *before* the resolver runs, so the data
 * fetch happens only once per sidebar entry. See {@link bookingsHydrationGuard}.
 */
export const servicesHydrationGuard: CanActivateFn = async (route, state) => {
  if (route.queryParamMap.keys.length > 0) return true;

  const storage = inject(StorageService);
  const router = inject(Router);

  const [storedTowns, storedPanelFilters] = await Promise.all([
    storage.getServicesAreas().catch(() => null).then(parseServicesTownsFromStorage),
    storage.getServicesFilters().catch(() => null).then(parseServicesPanelFilterParamsFromStorage),
  ]);
  const serialized = { towns: serializeIdList(storedTowns), ...storedPanelFilters };
  const queryParams: { [key: string]: string | number } = {};
  for (const [key, value] of Object.entries(serialized)) {
    if (value != null && value !== '') queryParams[key] = value as string;
  }
  if (Object.keys(queryParams).length === 0) return true;

  const path = state.url.split('?')[0];
  return router.createUrlTree([path], { queryParams });
};
